// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1a365d 0%, #0f2949 100%);
  padding: var(--spacing-lg);
}

.login-card {
  background: var(--surface-card);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-xl);
  padding: var(--spacing-2xl);
  width: 100%;
  max-width: 400px;
  text-align: center;
  animation: fadeInUp 0.6s ease-out;
  border: 1px solid var(--surface-border);
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-header {
  margin-bottom: var(--spacing-xl);
}

.login-logo {
  width: 64px;
  height: 64px;
  margin-bottom: var(--spacing-md);
  filter: drop-shadow(0 4px 8px rgba(255, 107, 53, 0.3));
}

.login-header h1 {
  font-size: var(--font-size-2xl);
  color: var(--color-secondary);
  margin-bottom: var(--spacing-sm);
  font-weight: 700;
}

.login-header p {
  color: var(--text-secondary);
  font-size: var(--font-size-base);
  line-height: 1.5;
}

.error-message {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: var(--color-danger);
  padding: var(--spacing-md);
  border-radius: var(--radius-md);
  margin-bottom: var(--spacing-lg);
  font-size: var(--font-size-sm);
}

.login-form {
  margin-bottom: var(--spacing-xl);
}

.google-login-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-md);
  padding: var(--spacing-md) var(--spacing-lg);
  border: 2px solid var(--surface-border);
  border-radius: var(--radius-md);
  background: var(--surface-card);
  color: var(--text-primary);
  font-size: var(--font-size-base);
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-base);
  position: relative;
  overflow: hidden;
}

.google-login-btn:hover:not(:disabled) {
  border-color: var(--color-gray-300);
  box-shadow: var(--shadow-md);
  transform: translateY(-1px);
}

.google-login-btn:active:not(:disabled) {
  transform: translateY(0);
}

.google-login-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none !important;
}

.google-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.login-footer {
  border-top: 1px solid var(--surface-border);
  padding-top: var(--spacing-lg);
}

.login-footer p {
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
  margin-bottom: var(--spacing-md);
}

.security-badges {
  display: flex;
  justify-content: center;
  gap: var(--spacing-md);
  flex-wrap: wrap;
}

.security-badge {
  font-size: var(--font-size-xs);
  color: var(--text-secondary);
  background: var(--color-gray-100);
  padding: var(--spacing-xs) var(--spacing-sm);
  border-radius: var(--radius-full);
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

/* Responsive adjustments */
@media (max-width: 480px) {
  .login-container {
    padding: var(--spacing-md);
  }
  
  .login-card {
    padding: var(--spacing-xl);
  }
  
  .security-badges {
    flex-direction: column;
    align-items: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Login.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,sDAAsD;AACxD;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,0BAA0B;EAC1B,0BAA0B;EAC1B,+BAA+B;EAC/B,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,4CAA4C;EAC5C,uCAAuC;EACvC,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,iCAAiC;EACjC,4CAA4C;EAC5C,iCAAiC;EACjC,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF","sourcesContent":[".login-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #1a365d 0%, #0f2949 100%);\n  padding: var(--spacing-lg);\n}\n\n.login-card {\n  background: var(--surface-card);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-xl);\n  padding: var(--spacing-2xl);\n  width: 100%;\n  max-width: 400px;\n  text-align: center;\n  animation: fadeInUp 0.6s ease-out;\n  border: 1px solid var(--surface-border);\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.login-header {\n  margin-bottom: var(--spacing-xl);\n}\n\n.login-logo {\n  width: 64px;\n  height: 64px;\n  margin-bottom: var(--spacing-md);\n  filter: drop-shadow(0 4px 8px rgba(255, 107, 53, 0.3));\n}\n\n.login-header h1 {\n  font-size: var(--font-size-2xl);\n  color: var(--color-secondary);\n  margin-bottom: var(--spacing-sm);\n  font-weight: 700;\n}\n\n.login-header p {\n  color: var(--text-secondary);\n  font-size: var(--font-size-base);\n  line-height: 1.5;\n}\n\n.error-message {\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  color: var(--color-danger);\n  padding: var(--spacing-md);\n  border-radius: var(--radius-md);\n  margin-bottom: var(--spacing-lg);\n  font-size: var(--font-size-sm);\n}\n\n.login-form {\n  margin-bottom: var(--spacing-xl);\n}\n\n.google-login-btn {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-md);\n  padding: var(--spacing-md) var(--spacing-lg);\n  border: 2px solid var(--surface-border);\n  border-radius: var(--radius-md);\n  background: var(--surface-card);\n  color: var(--text-primary);\n  font-size: var(--font-size-base);\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-base);\n  position: relative;\n  overflow: hidden;\n}\n\n.google-login-btn:hover:not(:disabled) {\n  border-color: var(--color-gray-300);\n  box-shadow: var(--shadow-md);\n  transform: translateY(-1px);\n}\n\n.google-login-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.google-login-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none !important;\n}\n\n.google-icon {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n.login-footer {\n  border-top: 1px solid var(--surface-border);\n  padding-top: var(--spacing-lg);\n}\n\n.login-footer p {\n  color: var(--text-secondary);\n  font-size: var(--font-size-sm);\n  margin-bottom: var(--spacing-md);\n}\n\n.security-badges {\n  display: flex;\n  justify-content: center;\n  gap: var(--spacing-md);\n  flex-wrap: wrap;\n}\n\n.security-badge {\n  font-size: var(--font-size-xs);\n  color: var(--text-secondary);\n  background: var(--color-gray-100);\n  padding: var(--spacing-xs) var(--spacing-sm);\n  border-radius: var(--radius-full);\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 480px) {\n  .login-container {\n    padding: var(--spacing-md);\n  }\n  \n  .login-card {\n    padding: var(--spacing-xl);\n  }\n  \n  .security-badges {\n    flex-direction: column;\n    align-items: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
